import { currentVersion } from "@src/appVersionConfigs";
import { theme } from "@src/theme";
import React from "react";

const BottomLeftVersionTag = () => {
  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        left: theme.margins.medium,
        textAlign: "center",
      }}
    >
      <p style={{ color: theme.colors.gray, fontSize: "0.8rem" }}>
        {currentVersion.version || ""}
      </p>
    </div>
  );
};

export default BottomLeftVersionTag;
